import { AuthContext } from "../contexts/CognitoContext";
import { useContext } from "react";

// const useAuth = () => useContext(AuthContext);
const useAuth = () => {
    const context = useContext(AuthContext);
  
    if (!context)
      throw new Error("AuthContext must be placed within AuthProvider");
  
    return context;
  };
  
export default useAuth;
